export default "__VITE_ASSET__BtzpBTu0__"